import React from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Typography
} from "@mui/material";
import { Stack, useTheme } from "@mui/system";

const AutobiaCheckbox = ({
  checked,
  onChange,
  label,
  disabled = false,
  error = false,
  helperText,
  color = "primary",
  size = "medium",
  indeterminate = false,
}) => {
  const theme = useTheme();

  return (
    <FormControl error={error} disabled={disabled}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            color={color}
            size={size}
            indeterminate={indeterminate}
            sx={{
              "&.Mui-checked": {
                color: color === "secondary" 
                  ? theme.palette.secondary.main 
                  : theme.palette.primary.main,
              },
              "&.MuiCheckbox-indeterminate": {
                color: color === "secondary" 
                  ? theme.palette.secondary.main 
                  : theme.palette.primary.main,
              },
              "&:hover": {
                backgroundColor: color === "secondary" 
                  ? `${theme.palette.secondary.main}08` 
                  : `${theme.palette.primary.main}08`,
              },
            }}
          />
        }
        label={
          <Typography
            variant="body2"
            color={disabled ? "gray.g400" : "gray.g700"}
            sx={{
              userSelect: "none",
              fontSize: size === "small" ? "0.8rem" : "0.875rem",
            }}
          >
            {label}
          </Typography>
        }
        sx={{
          margin: 0,
          alignItems: "flex-start",
        }}
      />
      {helperText && (
        <FormHelperText sx={{ mt: 0.5, ml: 4 }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default AutobiaCheckbox;